@if (visible) {
  <app-elfsight-popup campaignVisibilityFlag="salesCampaignPopup2024" campaignWidgetFlag="salesCampaignPopupWidgetId"></app-elfsight-popup>
}
